import { useCallback, useEffect, useMemo, useState } from 'react';

// An older revision opens in the editor itself, read-only, until the creator goes
// back to the latest one. A new latest revision (a finished run) brings it back too.
export default function useRevisionView(s) {
  const latestId = s.revision?.id;
  const [viewedId, setViewedId] = useState(null);
  useEffect(() => { setViewedId(null); }, [latestId]);
  const viewed = viewedId && viewedId !== latestId ? s.snapshot.revisions.find(r => r.id === viewedId) || null : null;
  const shown = viewed || s.revision || null;
  const show = useCallback(id => setViewedId(id === latestId ? null : id), [latestId]);
  const backToLatest = useCallback(() => setViewedId(null), []);
  // One identity while nothing changed: the editor is memoized on `view`.
  return useMemo(() => ({ viewed, shown, show, backToLatest }), [viewed, shown, show, backToLatest]);
}
